import { render } from "./speechBubblePointerArea.vue?vue&type=template&id=32bb3041&scoped=true"
import script from "./speechBubblePointerArea.vue?vue&type=script&lang=ts"
export * from "./speechBubblePointerArea.vue?vue&type=script&lang=ts"

import "./speechBubblePointerArea.vue?vue&type=style&index=0&id=32bb3041&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32bb3041"

export default script